import React from "react";

import { Dashboard } from "@mui/icons-material";
import { ActorTypes, FrontendActor } from "../../entity/models/FrontendActor";
import { NavBarStructure } from "./Constants";

export function getAdminTopBarButtons() {
  return [
    {
      hasSubTab: false,
      name: "Vendor Master",
      to: "/admin/dashboard",
      icon: <i className="fa-solid fa-list-check" />,
    },
    {
      hasSubTab: false,
      name: "Upload Invoice",
      to: "/admin/uploadInvoices",
      icon: <i className="fa-solid fa-cloud-arrow-up" />,
    },
    {
      hasSubTab: false,
      name: "CB Summary",
      to: "/admin/uploadClosingBalance",
      icon: <i className="fa-solid fa-file-upload" />,
    },
    {
      hasSubTab: false,
      name: "Operations Tracker",
      to: "/admin/operations",
      icon: <i className="fa-solid fa-briefcase" />,
    },
    {
      hasSubTab: false,
      name: "Amount Update",
      to: "/admin/reportTemplates",
      icon: <i className="fa-solid fa-file-arrow-down" />,
    },
  ] as NavBarStructure[];
}

export function getAnchorTopBarButtons() {
  return [
    {
      hasSubTab: false,
      name: "Dashboard",
      to: "/anchor/dashboard",
      icon: <i className="fa-solid fa-list-check" />,
    },
    {
      hasSubTab: false,
      name: "Upload Invoice",
      to: "/anchor/uploadInvoices",
      icon: <i className="fa-solid fa-cloud-arrow-up" />,
    },
    {
      hasSubTab: false,
      name: "CB Summary",
      to: "/anchor/uploadClosingBalance",
      icon: <i className="fa-solid fa-file-upload" />,
    },
  ] as NavBarStructure[];
}
export function getVendorTopBarButtons() {
  return [
    {
      hasSubTab: false,
      name: "Dashboard",
      to: "/vendor/dashboard",
      icon: <Dashboard />,
    },
  ] as NavBarStructure[];
}

export function getReconTopBarButtons(
  _pageName: string,
  _actorName: string,
  _openCollapseObj: Record<string, unknown>,
  actor: FrontendActor
) {
  let buttons: NavBarStructure[] = [];

  if (actor.actorType === ActorTypes.Admin) {
    buttons = getAdminTopBarButtons();
  } else if (actor.actorType === ActorTypes.Vendor) {
    buttons = getVendorTopBarButtons();
  } else if (actor.actorType === ActorTypes.Anchor) {
    buttons = getAnchorTopBarButtons();
  }

  const allNavBarButtons: NavBarStructure[] = [...buttons];

  const filteredSubMenu = allNavBarButtons?.map((navBarBtns) => {
    if (navBarBtns?.subMenu?.length > 0) {
      navBarBtns.subMenu = navBarBtns.subMenu.filter((subMenu) => (subMenu.show === undefined ? true : subMenu.show));
      return navBarBtns;
    } else return navBarBtns;
  });

  const filteredNavBarButtons = filteredSubMenu?.filter((button) => {
    if (button.show === undefined) {
      return true;
    }
    return button.show;
  });

  return filteredNavBarButtons;
}
